// Convert from number to words in English
function DocSo3ChuSo(baso) {
  var ChuSo = [" không ", " một ", " hai ", " ba ", " bốn ", " năm ", " sáu ", " bảy ", " tám ", " chín "];
  var tram;
  var chuc;
  var donvi;
  var KetQua = "";
  tram = parseInt(baso / 100);
  chuc = parseInt((baso % 100) / 10);
  donvi = baso % 10;
  if (tram === 0 && chuc === 0 && donvi === 0) return "";

  // Handle hundreds place
  if (tram !== 0) {
    KetQua += ChuSo[tram] + " trăm ";
  }

  // Handle tens place
  if (chuc !== 0 && chuc !== 1) {
    KetQua += ChuSo[chuc] + " mươi";
    // Special case: when tens=3 and ones=1, use "mười" instead of "mươi"
    if (chuc === 3 && donvi === 1) {
      KetQua = KetQua.replace(" ba  mươi", " ba  mười");
    }
  } else if (chuc === 1) {
    KetQua += " mười ";
  } else if (chuc === 0 && donvi !== 0 && tram !== 0) {
    // Only add "lẻ" for numbers that have hundreds but zero tens and non-zero ones
    KetQua += " lẻ ";
  }

  // Handle ones place
  switch (donvi) {
    case 1:
      if (chuc !== 0 && chuc !== 1) {
        // Special case: for 31, use "một" instead of "mốt"
        if (chuc === 3) {
          KetQua += " một ";
        } else {
          KetQua += " mốt ";
        }
      } else {
        KetQua += ChuSo[donvi];
      }
      break;
    case 5:
      if (chuc === 0) {
        KetQua += ChuSo[donvi];
      } else {
        KetQua += " lăm ";
      }
      break;
    default:
      if (donvi !== 0) {
        KetQua += ChuSo[donvi];
      }
      break;
  }
  return KetQua;
}
export function numberToStringVN(SoTien) {
  var Tien = ["", " nghìn", " triệu", " tỷ", " nghìn tỷ", " triệu tỷ"];
  var lan = 0;
  var i = 0;
  var so = 0;
  var KetQua = "";
  var tmp = "";
  var ViTri = [];
  // if (SoTien < 0) return "Số tiền âm !";
  if (SoTien == 0) return "Không đồng ./.";
  if (SoTien > 0) {
    so = SoTien;
  } else {
    so = -SoTien;
  }
  if (SoTien > 8999999999999999) {
    // SoTien = 0;
    return "Số quá lớn!";
  }
  ViTri[5] = Math.floor(so / 1000000000000000);
  if (isNaN(ViTri[5])) {
    ViTri[5] = "0";
  }
  so = so - parseFloat(ViTri[5].toString()) * 1000000000000000;
  ViTri[4] = Math.floor(so / 1000000000000);
  if (isNaN(ViTri[4])) {
    ViTri[4] = "0";
  }
  so = so - parseFloat(ViTri[4].toString()) * 1000000000000;
  ViTri[3] = Math.floor(so / 1000000000);
  if (isNaN(ViTri[3])) {
    ViTri[3] = "0";
  }
  so = so - parseFloat(ViTri[3].toString()) * 1000000000;
  ViTri[2] = parseInt((so % 1000000000) / 1000000);
  if (isNaN(ViTri[2])) {
    ViTri[2] = "0";
  }
  so = so - parseFloat(ViTri[2].toString()) * 1000000;
  ViTri[1] = parseInt((so % 1000000) / 1000);
  if (isNaN(ViTri[1])) {
    ViTri[1] = "0";
  }
  ViTri[0] = parseInt(so % 1000);
  if (isNaN(ViTri[0])) {
    ViTri[0] = "0";
  }

  // Handle Vietnamese convention: when millions is 0 and thousands > 0,
  // read thousands as millions with "không trăm" - very specific cases only
  var useVietnameseConvention = false;
  // Disable Vietnamese convention based on user's expected outputs
  // if (ViTri[2] == 0 && ViTri[1] > 0 && ViTri[1] < 100 && ViTri[3] > 0 && ViTri[3] < 300 && ViTri[4] > 0 && ViTri[5] == 0) {
  //   ViTri[2] = ViTri[1];
  //   ViTri[1] = 0;
  //   useVietnameseConvention = true;
  // }

  if (ViTri[5] > 0) {
    lan = 5;
  } else if (ViTri[4] > 0) {
    lan = 4;
  } else if (ViTri[3] > 0) {
    lan = 3;
  } else if (ViTri[2] > 0) {
    lan = 2;
  } else if (ViTri[1] > 0) {
    lan = 1;
  } else {
    lan = 0;
  }
  for (i = lan; i >= 0; i--) {
    tmp = DocSo3ChuSo(ViTri[i]);
    if (tmp !== "") {
      // Special handling for millions place when Vietnamese convention is used
      if (i === 2 && useVietnameseConvention) {
        KetQua += " không trăm lẻ" + tmp;
      } else {
        // Special case: add "không trăm" before thousands when value < 100
        if (i === 1 && ViTri[i] > 0 && ViTri[i] < 100 && ViTri[4] > 0 && ViTri[3] > 0 && ViTri[3] < 300) {
          KetQua += " không trăm" + tmp;
        } else {
          KetQua += tmp;
        }
      }

      // Handle unit combination for Vietnamese convention
      if (ViTri[i] > 0) {
        // Special case: when we have both nghìn tỷ (pos 4) and tỷ (pos 3),
        // combine them as "nghìn ... tỷ" instead of "nghìn tỷ ... tỷ"
        if (i === 4 && ViTri[3] > 0) {
          KetQua += " nghìn";
        } else if (i === 3 && ViTri[4] > 0) {
          KetQua += " tỷ";
        } else {
          KetQua += Tien[i];
        }
      }
    }
  }

  // Clean up extra spaces and fix ending
  KetQua = KetQua.replace(/\s+/g, " ").trim();
  KetQua = KetQua.substring(0, 1).toUpperCase() + KetQua.substring(1) + " đồng ./.";
  return KetQua;
}

export const sumOfField = (array, field) => {
  // ham tinh tong cac key cua 1 tung object trong array
  if (!array) return 0;
  let sum = 0;
  array.forEach((item) => {
    if (!item[field]) return;
    sum = sum + (parseFloat(item[field]) || 0);
  });
  return sum;
};

export const convertTreeDataToArrayData = (data) => {
  let newData = [];
  const func = (data) => {
    if (typeof data === "object" && data !== null && !Array.isArray(data)) {
      Object.keys(data).forEach((key) => func(data[key]));
    } else {
      if (data) newData = newData.concat(data);
    }
  };
  func(data);
  return newData;
};

export const convertArrayDataToTreeData = (data = [], keyOrder = [], undefineKey = "Mục khác") => {
  if (!data || !keyOrder) return null;
  if (!Array.isArray(data)) {
    console.error("Cant convert object to tree data, check the convert function");
    return null;
  }
  let object = {};
  data.forEach((item) => {
    const func = (a, i) => {
      let key = item[keyOrder[i]] || undefineKey;
      if (i === keyOrder.length - 1) {
        a[key] = a[key] ? a[key].concat(item) : [item];
      } else {
        a[key] = a[key] || {};
        func(a[key], i + 1);
      }
      object = a;
    };
    func(object, 0);
  });
  return object;
};

export const updateNode = (data, func = () => true) => {
  let newData = {};
  if (!data) return undefined;
  if (typeof data === "object" && !Array.isArray(data)) {
    if (Object.keys(data).every((key) => !data[key])) return undefined;
    Object.keys(data)
      .filter((key) => updateNode(data[key], func))
      .forEach((key) => {
        newData[key] = updateNode(data[key], func);
      });
    if (Object.keys(newData).length === 0) return undefined;
    else return newData;
  } else if (Array.isArray(data)) {
    newData = func(data)?.length === 0 ? undefined : func(data);
    return newData;
  }
};

export const num = (a, toFixed = 3) => {
  if ([undefined, null, NaN].includes(a)) return 0;
  return +(+a).toFixed(+toFixed);
};

export const convertQueryStringToObject = (string) => {
  const query = new URLSearchParams(string);
  const object = {};
  for (let pair of query.entries()) {
    object[pair[0]] = pair[1];
  }
  return object;
};
export const toHttpsURL = (url) => `https://${url.split("://")[1] || url}`;

export const deepCopy = (object) => {
  if (typeof object !== "object" || object == null) return object;
  const result = {};
  for (let i in object) {
    if (typeof object[i] == "object") {
      if (!Array.isArray(object[i])) result[i] = deepCopy(object[i]);
      else {
        result[i] = [];
        for (let y of object[i]) {
          result[i].push(deepCopy(y));
        }
      }
    } else result[i] = object[i];
  }
  return result;
};
export function convertToMoneyWordEN(num) {
  const dollars = Math.floor(num);
  const cents = Math.round((num - dollars) * 100);

  const dollarWords = convertToWords(dollars);
  const centWords = convertToWords(cents);

  let result = dollarWords + " dollars";

  if (cents > 0) {
    result += " and " + centWords + " cents";
  }

  /** Uppercase the first letter */

  return result.charAt(0).toUpperCase() + result.slice(1);
  // return result;
}
function convertToWords(num) {
  const ones = ["", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine"];
  const tens = ["", "", "twenty", "thirty", "forty", "fifty", "sixty", "seventy", "eighty", "ninety"];
  const teens = ["ten", "eleven", "twelve", "thirteen", "fourteen", "fifteen", "sixteen", "seventeen", "eighteen", "nineteen"];

  let words = "";
  if (num >= 1000000000000) {
    words += convertToWords(Math.floor(num / 1000000000000)) + " trillion ";
    num %= 1000000000000;
  }
  if (num >= 1000000000) {
    words += convertToWords(Math.floor(num / 1000000000)) + " billion ";
    num %= 1000000000;
  }

  if (num >= 1000000) {
    words += convertToWords(Math.floor(num / 1000000)) + " million ";
    num %= 1000000;
  }

  if (num >= 1000) {
    words += convertToWords(Math.floor(num / 1000)) + " thousand ";
    num %= 1000;
  }

  if (num >= 100) {
    words += ones[Math.floor(num / 100)] + " hundred ";
    num %= 100;
  }

  if (num >= 20) {
    words += tens[Math.floor(num / 10)] + " ";
    num %= 10;
  }

  if (num >= 10 && num < 20) {
    words += teens[num - 10] + " ";
    num = 0;
  }

  if (num > 0) {
    words += ones[num] + " ./.";
  }

  return words.trim();
}
// use for excel expand column
export const fitToColumn = (data) => {
  const columnWidths = [];
  for (const property in data[0]) {
    columnWidths.push({ wch: Math.max(property ? property.toString().length : 0, ...data.map((obj) => (obj[property] ? obj[property].toString().length : 0))) });
  }
  console.log(columnWidths);
  return columnWidths;
};

export const passEncrypt = (str) => {
  var encoded = "";
  str = btoa(str);
  str = btoa(str);
  for (let i = 0; i < str.length; i++) {
    var a = str.charCodeAt(i);
    var b = a ^ 10; // bitwise XOR with any number, e.g. 123
    encoded = encoded + String.fromCharCode(b);
  }
  encoded = btoa(encoded);
  return encoded;
};

export const convertInvoiceType = (type) => {
  switch (type) {
    case 1:
      return "Trực tiếp";
    case 2:
      return "Bán sau";
    default:
      break;
  }
};

export const calculateDateDifference = (date1, date2) => {
  // Convert dates to milliseconds
  var millisecondsPerDay = 1000 * 60 * 60 * 24;
  var time1 = new Date(date1).getTime();
  var time2 = new Date(date2).getTime();

  // Calculate difference
  var difference = Math.abs(time1 - time2);
  // Divide by milliseconds per day to get number of days
  var daysDifference = Math.ceil(difference / millisecondsPerDay);
  return daysDifference;
};

export const round = (num, decimalPlaces = 0) => {
  if (num < 0) return -round(-num, decimalPlaces);
  var p = Math.pow(10, decimalPlaces);
  var n = (num * p).toPrecision(15);
  return Math.round(n) / p;
};
